module.exports = __webpack_public_path__ + "static/img/back-6-1.0741fe33.png";